import { TextMap } from '../types'

const en: TextMap = {
  choose_preferred_wallet: 'Choose your preferred wallet',
  connect_mobile_wallet: 'Connect to GotaBit Mobile Wallet',
  scan_qrcode_with_wallet: 'scan qrcode with GotaBit Wallet',
  connect: 'Connect',
  qrcode: 'QR Code',
  mobile: 'Mobile',
  desktop: 'Desktop',
  copy_to_clipboard: 'Copy to clipboard',
  copied_to_clipboard: 'Copied to clipboard!',
  connect_with: 'Connect with',
  loading: 'Loading...',
  something_went_wrong: 'Something went wrong',
  no_supported_wallets: 'There are no supported wallets yet',
  no_wallets_found: 'No wallets found',
}

export default en
